var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":"https://penilaiankinerja.bkpm.go.id:2087/public/upload/1721058786_Buku%20Panduan%20BimTek%20-%20Modul%20Peserta.pdf","width":"100%","height":"600"}})])
}]

export { render, staticRenderFns }